import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {QuestionType} from '../../constants';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {MiniQuestionFlowSessionQuery} from '../state/mini-question-flow-session.query';

@Component({
    selector: 'app-question-location-edit',
    templateUrl: './question-location-edit.component.html',
    styleUrls: ['./question-location-edit.component.scss'],
    standalone: false
})
export class QuestionLocationEditComponent implements OnInit {

  @Input() question: Question;
  session_details: any;
  @Output() questionAnswer = new EventEmitter<any>();
  childQuestion: Question;
  item_ids: number[] = [];
  groupings: [string, any][] = [];

  answeredQuestions: any[] = [];

  max_item_id: string = null;
  edit = false;

  constructor(public globalQuestionService: GlobalQuestionService,
    private sessionQuery: MiniQuestionFlowSessionQuery) { }

  ngOnInit(): void {
    this.session_details = this.sessionQuery.getValue();
    this.loadResponses();
  }

  editItem(item_id: any){
    console.log('Edit:: ' + item_id);
  }

  loadResponses(){
    this.item_ids = [];
    this.answeredQuestions = [];

    this.globalQuestionService.getChildrenQuestions(this.question?.cent_aq_question_id)
      .subscribe((questions: Question[]) => {
        if(!questions){
          return;
        }
        this.childQuestion = Object.assign({}, questions[0]);
        this.globalQuestionService.getResponses()
        .subscribe((questions: any[]) => {
          if(!questions){
            return;
          }
          questions.forEach((question: any) => {
            if(question.flow_id == this.childQuestion?.dependant_flow_id){
              this.answeredQuestions.push(Object.assign({}, question));
            }
          });

          this.groupings = this.groupByItemId(this.answeredQuestions);
          if(this.groupings?.length > 0){
            this.groupings.forEach((i: any) => {
              this.item_ids.push(+i[0]);
            });

            this.max_item_id = Math.max.apply(null, this.item_ids).toString();
          }else{
            this.max_item_id = "0";
          }
        });
      });
  }

  getConcatenatedAddress(address: any){
    return `${address?.streetAddress}, ${address?.suburb}`;
  }

  getAddress(group: any){
    var addressQuestion = group[1]?.find((q: any) => q.cent_aq_question_type_id === QuestionType.address);
    var address: any = {};
    if(addressQuestion){
      const answer = addressQuestion.answer.split(',');
      if (answer.length < 7) {
        address.streetAddress = answer[0];
        address.suburb = answer[1];
        address.province = answer[2];
        address.city = answer[3];
        address.postalCode = answer[4];
      } else {
        address.apartmentNo = answer[0];
        address.complex = answer[1];
        address.streetAddress = answer[2];
        address.suburb = answer[3];
        address.province = answer[4];
        address.city = answer[5];
        address.postalCode = answer[6];
      }
    }

    return address;
  }

  groupByItemId(questions: any): [string, any][]{
    const groupsDict: {} = questions?.reduce((r: any, a: any) => {
      r[a.item_id] = [...r[a.item_id] || [], a];
      return r;
    }, {});

    const groupsArray = Object.entries(groupsDict);

    return groupsArray;
  }

  submitResponse(event){
    console.log('Response....' + JSON.stringify(event));
    this.childQuestion.answer = event?.answer;
    this.loadResponses();
  }

}


